import { screenReaderContainerStyles } from '../../../../utils';
export var chatMessageReadStatusStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    return {
      position: 'absolute',
      right: v.rightPoistion,
      bottom: v.bottomPoistion,
      ':after': Object.assign({
        content: "\"" + p.title + "\""
      }, screenReaderContainerStyles)
    };
  }
};
//# sourceMappingURL=chatMessageReadStatusStyles.js.map
